import * as React from "react";
import { Button, Flex, FieldTextGroup } from "@theorgchartdev/storybook";
import SectionCard, { SectionCardGroup } from "../../../../Composites/SectionCard/SectionCard";
import * as StateLib from "@/Utils/StateLib";
import { GetUserList } from "@/Utils/Promises";
import { useEffect, useState } from "react";
import { GetUsedSeats } from "../../AccountSettings/ManageUsers/Utils";
import { GetWSMgr } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";
import { kAdminUser, kEditionLabels, kRWUser } from "@coreapp/constants";

export const AccountDetails = () => {
  const [users, setUsers] = useState(null);
  const [groups, setGroups] = useState(null);

  const LoadUsers = async () => {
    const { userList, groupInfo } = await GetUserList();
    setGroups(groupInfo?.groups);
    setUsers(userList);
  };

  useEffect(() => {
    const eventTracker = wsMgr.GetUsageTracker();
    eventTracker.ReportEvent("account_settings.account_details.opened");
    const userRole = Globals._accountInfo.GetUserRole();
    if ([kAdminUser, kRWUser].includes(userRole)) {
      LoadUsers();
    }
  }, []);

  const wsMgr = GetWSMgr();
  if (!wsMgr) return;

  const addFieldText = (field, value, data) => {
    data.push({ field: field, value: value });
  };

  const getData = () => {
    const wsMgr = GetWSMgr();
    const oi = wsMgr.GetOrgInfo();
    const curDoc = wsMgr.GetDoc();
    const orgInfo = wsMgr.fOrgInfo;
    const boxLimit = wsMgr.GetBoxCount();
    const orgID = wsMgr.GetAccountName();
    const expireDate = wsMgr.GetExpireDate();
    const startDate = orgInfo.fAccountDetails.GetStartDate();
    const rawEdition = Globals._accountInfo.GetOC5Edition();
    const edition = kEditionLabels[rawEdition] ?? rawEdition;
    const companyName = orgInfo.GetOrgName();
    const seatCount = oi.GetSeatCount();
    const curBox = orgInfo.fCurBoxUsage >= 0 ? orgInfo.fCurBoxUsage : null;

    const data = [];
    addFieldText(appstr("companyname"), companyName, data);
    addFieldText(appstr("OrgID"), orgID, data);
    addFieldText(appstr("edition"), edition, data);
    addFieldText(appstr("expiredate"), expireDate, data);
    addFieldText(appstr("startdate"), startDate, data);
    addFieldText(appstr("Seat limit"), seatCount, data);
    addFieldText(appstr("Currently used seats"), GetUsedSeats(users, groups), data);
    addFieldText(appstr("boxlimit"), boxLimit, data);
    addFieldText(appstr("Currently used boxes"), curBox, data);

    return data;
  };

  const onClickPrivacy = () => {
    const wsMgr = StateLib.GetWSMgr();
    const eventTracker = wsMgr.GetUsageTracker();
    eventTracker.ReportEvent("account_settings.privacy_policy.opened");
    wsMgr.LaunchHelp("privacy");
  };

  const onClickTerms = () => {
    const wsMgr = StateLib.GetWSMgr();
    const eventTracker = wsMgr.GetUsageTracker();
    eventTracker.ReportEvent("account_settings.terms_of_service.opened");
    wsMgr.LaunchHelp("terms");
  };

  return (
    <SectionCardGroup>
      <SectionCard title={appstr("acctdetails")}>
        <Flex gap={"20px"} direction={"column"} justifyContent={"space-between"}>
          <Flex direction={"column"} gap={"16px"} height={"100%"}>
            <FieldTextGroup columnGap={200} columns={2} data={getData()} size={"large"} />
          </Flex>
          <Flex>
            <Button
              modifier="link"
              color="info"
              id="privacy"
              onClick={onClickPrivacy}
              size={"small"}
            >
              {appstr("Privacy policy")}
            </Button>
            <Button modifier="link" color="info" id="terms" onClick={onClickTerms} size={"small"}>
              {appstr("Terms of service")}
            </Button>
          </Flex>
        </Flex>
      </SectionCard>
    </SectionCardGroup>
  );
};
